import { Box, BoxProps } from "@chakra-ui/react";

type GoogleIconProps = {
  name: string;
} & BoxProps;

const GoogleIcon = ({ name, fontSize, ...rest }: GoogleIconProps) => {
  return (
    <Box
      aria-hidden="true"
      className="material-symbols-sharp"
      fontSize={fontSize ?? 48}
      {...rest}
    >
      {name}
    </Box>
  );
};

export default GoogleIcon;
